import { useCallback } from 'react';
import { formatGraphqlErrors } from 'utils/helpers';
import { useMutation } from '@apollo/client/react';
import { UpdateBudgetDocument, type UpdateBudgetInput } from 'graphql/generated/graphql';
import requireValue from 'utils/requireValue';

const useUpdateBudget = () => {
  const [updateBudgetMutation] = useMutation(UpdateBudgetDocument);

  const updateCalculatedBudgetValues = useCallback(
    async (formData: UpdateBudgetInput) => {
      try {
        const res = await updateBudgetMutation({ variables: { formData } });
        const { updateBudget } = requireValue(res.data, 'updateBudget');

        return updateBudget;
      } catch (error) {
        const e = formatGraphqlErrors(error);
        throw e;
      }
    },
    [updateBudgetMutation],
  );
  return updateCalculatedBudgetValues;
};

export default useUpdateBudget;
